export default "__VITE_ASSET__BDAQebfg__"